module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-snackbar', {
    staticClass: "snackbar",
    attrs: {
      "timeout": _vm.timeout,
      "color": _vm.color,
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(ref) {
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._b({
          attrs: {
            "color": "white",
            "text": ""
          },
          on: {
            "click": _vm.close
          }
        }, 'v-btn', attrs, false), [_c('v-icon', [_vm._v("close")])], 1)]
      }
    }]),
    model: {
      value: (_vm.showSnackbar),
      callback: function($$v) {
        _vm.showSnackbar = $$v
      },
      expression: "showSnackbar"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.text) + "\n  ")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ce0c9a1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/GlobalSnackbar.vue
// module id = 887
// module chunks = 0 2